import React from "react";
import classNames from "classnames";
import { USER_ROLES } from "../../utils/userUtils";
import { Trans as T } from 'react-i18next';
import Dropdown from 'react-bootstrap/Dropdown';

import ChevronIcon from "../../assets/icons/ChevronIcon";
import './UserRoleDropdown.scss';

export default function UserRoleDropdown({ role: roleType, onChange, type, placeholder, fixed, disabled }) {

  const selectedRole = USER_ROLES[roleType];
  
  return (
    <Dropdown className={classNames('__user-role-dropdown', { [`__user-role-dropdown-${type}`]: type })}>
      <Dropdown.Toggle disabled={disabled} as={Toggle} className='dropdown-toggle'>
        <div className="toggle-overflow">
          <div className={classNames('label', { unassigned: !selectedRole })}><T>{ selectedRole || placeholder || 'No role set' }</T></div>
          <ChevronIcon className='chevron' />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu renderOnMount={fixed} popperConfig={fixed && { strategy: 'fixed' }}>
        { Object.entries(USER_ROLES).map(([key, value]) => (
          <Dropdown.Item as='button' key={key} active={roleType === key} onClick={() => onChange(key)}><T>{ value }</T></Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

const Toggle = React.forwardRef(({ children, onClick, ...props }, ref) => (
  <button onClick={onClick} ref={ref} {...props}>
    { children }
  </button>
));
